const errorMessages = {
  default: "Campo inválido",
  required: "Campo obrigatório",
  pattern: "Formato inválido",
  minLength: "Mínimo de caracteres não atingido",
  maxLength: "Máximo de caracteres excedido",
  min: "Valor mínimo não atingido",
  max: "Valor máximo excedido",
  validate: "Valor inválido",
};

const getErrorMessage = (type) => {
  const errorMessage = errorMessages[type || "default"];
  return errorMessage || "Erro desconhecido";
};

export function retrieveFieldError(fieldName, errors) {
  const [nestedAttributesFieldName, index, subFieldName] = fieldName.split(".");

  const error =
    nestedAttributesFieldName && index && subFieldName
      ? errors[nestedAttributesFieldName]?.[index]?.[subFieldName]
      : errors[fieldName];

  return error && (error?.message || getErrorMessage(error?.type?.toString()));
}
